<template>
  <div id="clip">
    <el-row class="filtri">
      <!-- Calamite -->
      <!-- <el-col v-if="numberOfClips <= 0" class="calamite filter" :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 14, offset: 1 }" :lg="{ span: 6, offset: 1 }">
        <el-col class="title" :span="24">INCLUDI CALAMITE</el-col>
        <el-col class="misure col-filter" :span="12" :class="{ activeClip: includeMagnets }">
          <el-button type="text" @click="changeIncludeMagnets(true)">
            <span>SI</span>
          </el-button>
        </el-col>
        <el-col class="misure col-filter" :span="12" :class="{ activeClip: !includeMagnets }">
          <el-button type="text" @click="changeIncludeMagnets(false)">
            <span>NO</span>
          </el-button>
        </el-col>
      </el-col> -->

      <!-- Numero di clip -->
      <el-col class="clip-numero filter" :xs="{ span: 24, offset: 0 }" :sm="{ span: 14, offset: 1 }"
        :lg="{ span: 6, offset: 2 }">
        <el-col class="title" :span="24">NUMERO DI CLIP</el-col>
        <el-col class="number col-filter" v-for="(number, idx) in [$t('NO'), '1', '2', '3', '4']" :key="idx"
          :span="2" :offset="2" :class="{ activeClip: numberOfClips === idx }">
          <el-button @click="changeClip(idx)" class="btn-number" type="text">
            <span>{{ number }}</span>
          </el-button>
        </el-col>
      </el-col>
      <el-col class="clip-numero filter" :xs="{ span: 24, offset: 0 }" :sm="{ span: 14, offset: 1 }"
        :lg="{ span: 6, offset: 1 }">
        <el-col class="title" :span="24">VISUALIZZA CLIP</el-col>
        <!-- Bottone "NO" attivo di default -->
        <el-col class="number col-filter" :span="4" :offset="2" :class="{ activeClip: clipToVisualize === 0 }">
          <el-button @click="changeViewClip(0)" class="btn-number" type="text">
            <span>NO</span>
          </el-button>
        </el-col>
        <!-- Bottoni delle clip -->
        <el-col class="number col-filter" v-for="(clip, idx) in numberOfClips" :key="clip" :span="2" :offset="2"
          :class="{ activeClip: clipToVisualize === clip }">
          <el-button @click="changeViewClip(clip)" class="btn-number" type="text"
            :disabled="idx >= selectedClips.length">
            <span>{{ clip }}</span>
          </el-button>
        </el-col>

      </el-col>
    </el-row>


    <div class="colori" v-if="numberOfClips > 0">
      <div v-for="clip in lentiSole" :key="clip.ItemCode"
        :class="{ active: selectedClips.findIndex((l) => l.ItemCode == clip.ItemCode) != -1 }"
        @click="setClipLensesModel(clip)" class="color">
        <div class="img-colori">
          <div class="number-clip-active" v-if="selectedClips.findIndex((l) => l.ItemCode == clip.ItemCode) != -1">
            {{selectedClips.findIndex((l) => l.ItemCode == clip.ItemCode) + 1}}
          </div>
          <img :src="clip.imageUrl" alt="color" />
          <div style="font-size: 10px;">
            {{ clip.ItemName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      includeMagnets: true, // Flag per includere calamite
    };
  },
  watch: {
    numberOfClips(newV) {
      if (newV > 0 && !this.clipOn) {
        if (this.correspondingFrontaleWithClip) {
          this.$store.commit("configurator/setFrontal", this.correspondingFrontaleWithClip);
        }
        this.clipOn = this.correspondingClip;
        this.showClip = false;
      } else if (newV <= 0 && this.clipOn) {
        if (this.correspondingFrontaleWithoutClip) {
          this.$store.commit("configurator/setFrontal", this.correspondingFrontaleWithClip);
        }
        this.$store.commit("configurator/setLenteClipToVisualize", null);
        this.$store.commit("configurator/setClipLensesModels", []);
        this.clipOn = null;
      }
      if (this.selectedClips.length > newV) {
        this.selectedClips.splice(newV);
      }

      if (this.clipToVisualize > newV) {
        this.clipToVisualize = this.selectedClips.length;
      }
    },
    includeMagnets(newValue) {
      // Cambia il frontale in base alle calamite selezionate
      if (newValue) {
        this.$store.commit("configurator/setFrontal", this.correspondingFrontaleWithClip);
      } else {
        this.$store.commit("configurator/setFrontal", this.correspondingFrontaleWithoutClip);
      }
    },
    clipToVisualize(newV) {
      if (!this.showClip && newV > 0 && this.numberOfClips > 0) {
        this.showClip = true;
      }
      if (newV == 0) {
        this.showClip = false;
      } else if (newV <= this.selectedClips.length) {
        this.$store.commit("configurator/setLenteClipToVisualize", this.selectedClips[newV - 1]);
      } else {
        this.$store.commit("configurator/setLenteClipToVisualize", null);
      }
    },
  },
  methods: {
    changeIncludeMagnets(value) {
      this.includeMagnets = value;
    },
    changeClip(index) {
      this.numberOfClips = index;
    },
    changeViewClip(clipNumber) {
      this.clipToVisualize = clipNumber;
    },
    setClipLensesModel(l) {
      const correspondingClip = this.selectedClips.findIndex((selected) => selected.ItemCode == l.ItemCode);
      if (correspondingClip != -1) {
        // The user clicked on an already chosen clip -> remove it
        this.$store.commit("configurator/removeClipLensesModel", l);
        this.clipToVisualize = this.selectedClips.length;
      } else {
        if (this.selectedClips.length < this.numberOfClips) {
          this.$store.commit("configurator/addClipLensesModel", l);
          this.clipToVisualize = this.selectedClips.length;
          this.$store.commit("configurator/setLenteClipToVisualize", l);
        } else if (this.selectedClips.length > 0) {
          this.$store.commit("configurator/replaceClipLensesModel", {
            lens: l,
            index: this.selectedClips.length - 1
          });
          this.clipToVisualize = this.selectedClips.length;
          this.$store.commit("configurator/setLenteClipToVisualize", l);
        }
      }
    },
  },
  computed: {
    clipToVisualize: {
      get() {
        return this.$store.state.clipToVisualize || 0;
      },
      set(value) {
        this.$store.commit("setClipToVisualize", value);
      }
    },
    lentiSole() {
      // Ottieni le clip dal Vuex store
      return this.$store.getters["configurator/lenti/clipLenses"];
    },
    numberOfClips: {
      get() {
        return this.$store.state.configurator.numberOfClips;
      },
      set(value) {
        this.includeMagnets = true;
        this.$store.commit("configurator/setNumberOfClips", value);
      }
    },
    clipOn: {
      get() {
        return this.$store.state.configurator.clip != null;
      },
      set(co) {
        if (this.frontale) {
          this.$store.commit("configurator/setClip", co ? this.correspondingClip : null);
        }
      },
    },
    correspondingFrontaleWithClip() {
      return this.$store.getters["configurator/correspondingFrontalWithClip"];
    },
    correspondingFrontaleWithoutClip() {
      return this.$store.getters["configurator/correspondingFrontalWithoutClip"];
    },
    correspondingClip() {
      return this.$store.getters["configurator/correspondingClip"];
    },
    selectedClips() {
      return this.$store.state.configurator.lentiSoleClip;
    },
    showClip: {
      get() {
        return this.$store.state.configurator.showClip;
      },
      set(show) {
        this.$store.state.configurator.showClip = show;
      }
    },
    frontale() {
      return this.$store.state.configurator.frontale;
    }
  }
};
</script>

<style lang="less">
.activeClip {
  background-color: #f5821f;
  cursor: pointer;

  .el-button {
    span {
      color: white;
    }
  }
}

#clip {
  height: 34vh;

  .filtri {
    margin: 10px 0;
    background-color: #ededed;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .calamite {}

    .filter {
      .title {
        border-bottom: 2px solid #4d4d4d;
        padding-bottom: 10px;
        margin-top: 10px;
      }
    }

    .clip-numero {
      .number {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn-number {
          width: 100%;
        }
      }
    }
  }

  .colori {
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-behavior: smooth;
    justify-content: center;
    height: calc(80% - 55px);
    gap: 3em;

    .color {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .img-colori {
        border-radius: 10%;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 15px;

        .number-clip-active {
          position: absolute;
          top: 0;
          left: 0;
          background-color: #f5821f;
          color: white;
          padding: 5px;
          width: 10%;
          /* border-radius: 50%; */
          height: 10%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
        }

        img {
          margin: 10px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 5px solid transparent;
        }
      }
    }

    .active {
      .img-colori {
        img {
          border: 5px solid #f5821f;
        }
      }
    }
  }
}
</style>
